export class NumberType {
  static get InstallationQuotation () {
    return 1
  }
  static get RemoveQuotation () {
    return 2
  }
  static get ReturnQuotation () {
    return 3
  }
  static get RepairQuotation () {
    return 4
  }
  static get MonthQuotation () {
    return 5
  }
  static get Fix () {
    return 6
  }
  static get Init () {
    return 7
  }
  static get Acceptance () {
    return 8
  }
  static get Repair () {
    return 9
  }
  static get Sale () {
    return 10
  }
  static get Notice () {
    return 11
  }
  static get OffsetQuotation () {
    return 12
  }
  static get MoveQuotation () {
    return 13
  }
  static get ExcelImport () {
    return 14
  }
  static get ChangeDetail () {
    return 15
  }
  static get Overage () {
    return 16
  }
  static get Month () {
    return 17
  }
  static get Discount () {
    return 18
  }
  static get Resume () {
    return 19
  }
  static get Order () {
    return 20
  }
  static get TryQuotation () {
    return 21
  }

  static NumberTypeName (NumberType) {
    let tmpType = parseInt(NumberType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '新裝機報價單'
        break
      case 2:
        name = '拆機報價單'
        break
      case 3:
        name = '回裝報價單'
        break
      case 4:
        name = '維修報價單'
        break
      case 5:
        name = '月租報價單'
        break
      case 6:
        name = '叫修單'
        break
      case 7:
        name = '初始化'
        break
      case 8:
        name = '安裝驗收單'
        break
      case 9:
        name = '維修單'
        break
      case 10:
        name = '銷貨單'
        break
      case 11:
        name = '安裝通知單'
        break
      case 12:
        name = '補單報價單'
        break
      case 13:
        name = '移機報價單'
        break
      case 14:
        name = 'Excel匯入'
        break
      case 15:
        name = '變更作業'
        break
      case 16:
        name = '預收作業'
        break
      case 17:
        name = '月租檔'
        break
      case 18:
        name = '月租優惠'
        break
      case 19:
        name = '履歷卡'
        break
      case 20:
        name = '訂單'
        break
      case 21:
        name = '試裝單'
        break
    }
    return name
  }
}
